import { ReactNode } from 'react';
import { Link as RouterLink } from 'react-router-dom';

type SmartLinkProps = Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> & {
  href: string;
  children: ReactNode;
};

function isExternalHref(href: string) {
  return (
    href.startsWith('http') ||
    href.startsWith('mailto:') ||
    href.startsWith('tel:') ||
    href.startsWith('/api/')
  );
}

/**
 * Smart link component that automatically uses <a> for external URLs
 * and React Router's Link for internal navigation.
 */
function SmartLink({ href, children, ...rest }: SmartLinkProps) {
  if (isExternalHref(href)) {
    return (
      <a href={href} {...rest}>
        {children}
      </a>
    );
  }

  return (
    <RouterLink to={href} {...rest}>
      {children}
    </RouterLink>
  );
}

export default SmartLink;
